import { useState, useCallback } from 'react';
import { Routes } from '../types/routes';

import { onChangeRoutes, getRouteById, resetRoutes } from '../types/routes';
import { setRoutesError } from '../types/routesError';

const useRoutes = (setRoutesError: setRoutesError) => {
  const [ routes, setRoutes ] = useState<Routes>();

  const onChangeRoutes: onChangeRoutes = useCallback((routes, routesError) => {
    setRoutes(routes);
    setRoutesError(routesError)
  }, [setRoutes, setRoutesError]);

  const getRouteById: getRouteById = useCallback(id => (routes || [])
    .find(route => route.id === id),
  [routes]);

  const resetRoutes: resetRoutes = useCallback(() => {
    setRoutes(undefined);
  }, [setRoutes]);

  return { routes, setRoutes, onChangeRoutes, getRouteById, resetRoutes };
};

export default useRoutes;
